window.addEventListener('DOMContentLoaded', () => {
  const accordions = [...document.getElementsByClassName('wp-block-bigbite-accordion-group')];

  // Function which opens & closes accordion items and sets aria-expanded for accessibility.
  function checkClass(closestItem) {
    closestItem.classList.toggle('is-open');
    closestItem.classList.toggle('is-closed');
    const headingWrapper = closestItem.children[0];
    if (closestItem.classList.contains('is-open')) {
      headingWrapper.children[0].setAttribute('aria-expanded', true);
    } else if (closestItem.classList.contains('is-closed')) {
      headingWrapper.children[0].setAttribute('aria-expanded', false);
    }
  }

  // Function to check if the click is in the accordion summary section
  const handleAccordionClick = (event) => {
    const clickTarget = event.target;
    const closestItem = clickTarget.closest('.wp-block-bigbite-accordion-item');
    const clickTargetParent = [...clickTarget.parentElement.classList];
    const isInItem = closestItem.contains(clickTarget);
    const isInDetailsWrapper =
      clickTargetParent.includes('bbAccordion_details-detailsWrapper') ||
      clickTargetParent.includes('wp-block-bigbite-accordion-item');
    const validClick = isInItem && !isInDetailsWrapper;
    if (!validClick) {
      return;
    }
    checkClass(closestItem);
  };

  // Function to handle arrow keys input
  const handleArrows = (keydownTarget, buttons, key) => {
    for (let i = 0; i < buttons.length; i += 1) {
      if (keydownTarget === buttons[i]) {
        switch (key) {
          case 'up':
            buttons[i - 1].focus();
            break;
          case 'down':
            buttons[i + 1].focus();
            break;
          default:
        }
      }
    }
  };

  // Function to handle key presses for accessibility.
  const handleAccordionKeydown = (event) => {
    const keydownTarget = event.target;
    if (keydownTarget.className !== 'bbAccordion_summary-headingWrapper') {
      return;
    }
    const keydownAction = event.code;
    const buttonsParent = keydownTarget.closest('.wp-block-bigbite-accordion-group');
    const buttons = buttonsParent.querySelectorAll('.bbAccordion_summary-headingWrapper');
    const closestButton = keydownTarget.closest('.bbAccordion_summary-headingWrapper');
    const closestItem = keydownTarget.closest('.wp-block-bigbite-accordion-item');
    switch (keydownAction) {
      case 'ArrowUp':
        event.preventDefault();
        // Move upwards to the next accordion item as long as it's not the first in the group.
        if (closestButton !== buttons[0]) {
          handleArrows(keydownTarget, buttons, 'up');
        }
        break;
      case 'ArrowDown':
        event.preventDefault();
        // Move upwards to the next accordion item as long as it's not the last in the group.
        if (closestButton !== buttons[buttons.length - 1]) {
          handleArrows(keydownTarget, buttons, 'down');
        }
        break;
      case 'Enter':
      case 'Space':
        event.preventDefault();
        // Open/close the accordion depending on its current state.
        checkClass(closestItem);
        break;
      default:
    }
  };

  accordions.forEach((accordion) => {
    accordion.addEventListener('click', handleAccordionClick);
    accordion.addEventListener('keydown', handleAccordionKeydown);
  });
});
